import NavSideBar from "../component/NavSideBar";

export default function Animations() {
    return (
      <NavSideBar>
          <div className="p-10 text-3xl font-bold">Animations</div>
      </NavSideBar>
    )
  }